<template>
  <template v-if="route.name === 'browse'">
    <ViewHeader />
    <Block>
      <List>
        <ListItem
          :text="$t('routes.categoryContainer.menuTitle')"
          :to="{ name: 'categoryContainer' }"
        >
          <template #icon>
            <i-mdi-archive />
          </template>
        </ListItem>
        <ListItem
          :text="$t('routes.countryContainer.menuTitle')"
          :to="{ name: 'countryContainer' }"
        >
          <template #icon>
            <i-mdi-map />
          </template>
        </ListItem>
      </List>
    </Block>
  </template>
  <router-view />
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
</script>
